import React from 'react'
import { Text, View } from 'oio-react'
import { useParams } from 'react-router-dom'
import tinycolor from 'tinycolor2'
import UserBadgeSash from 'src/sites/kits/People/components/UserBadgeSash'
import ProfileActions from 'src/sites/kits/Profile/components/Actions'
import { Title, Token } from 'src/sites/kits/UI'
import { useUser } from 'src/core/graphql/hooks'
import { useGlobalState } from 'src/sites/state'

const ProfileAboutBlock = () => {
   const { userId } = useParams()
   const { theme } = useGlobalState()
   const { user } = useUser({ id: userId })

   const tokenBackgroundColor = tinycolor(theme.tmpContentTitleColor).setAlpha(0.1).toRgbString()
   const avatarUrl = user.avatarMedia
      ? user.avatarMedia?.file.thumbnailUrlW240
      : '/assets/images/avatarPlaceholder.svg'

   return (
      <View width="100%" flexFlow="column" height="100%[d-f]">
         <View flex="1 1 auto">
            <View
               display="flex"
               flexFlow="row-reverse"
               width="100%">
               <View
                  flex="0 0 auto"
                  width="70px[a-b] 90px[c] 60px[d-f]"
                  height="70px[a-b] 90px[c] 60px[d-f]"
                  marginBottom="30px[d-f]"
                  borderRadius="5px"
                  backgroundColor="#eee"
                  backgroundImage={`url(${avatarUrl})`}
                  backgroundSize={user.avatarMedia ? 'cover' : '90% 90%'}
                  backgroundPosition="bottom center"
                  backgroundRepeat="no-repeat"
               />
               <View
                  flex="1 1 auto"
                  width="100%"
                  paddingRight="20px[a-d]">
                  <Title size="lg">
                     {user.fullName}
                  </Title>
                  <View opacity="0.5">
                     <Text size="2.5" color={theme.tmpContentTitleColor}>
                        {user.position}
                        {user.position && user.organization && ', '}
                        {user.organization}
                     </Text>
                  </View>
                  <UserBadgeSash
                     badges={user.badges}
                     size="lg"
                     style={{ margin: '15px 0 0 0' }}
                  />
               </View>
            </View>
            {(user.bio || user.skills.length > 0 || user.certifications.length > 0) && (
               <View
                  marginTop={theme.tmpSpacingTop}
                  width="100%"
                  borderTop={`1px solid ${theme.tmpAsideLineColor}`}
               />
            )}
            {user.bio && (
               <View maxWidth="650px" marginTop={theme.tmpSpacingTop} opacity="0.7">
                  <Text
                     size={theme.tmpBodyTextSize}
                     color={theme.tmpBodyTextColor}
                     lineHeight={theme.tmpBodyTextLineHeight}>
                     {user.bio}
                  </Text>
               </View>
            )}
            {user.skills.length > 0 && (
               <View
                  width="100%"
                  paddingTop="20px[a-d] 30px[e-f]">
                  <Text
                     size={theme.tmpBodyTextSize}
                     weight="medium"
                     color={theme.tmpContentTitleColor}>
                     Skills
                  </Text>
                  <View maxWidth="650px" marginTop="10px" opacity="0.5">
                     {user.skills.map(skill => (
                        <Token
                           key={skill}
                           backgroundColor={tokenBackgroundColor}
                           name={skill}
                           size="lg"
                           textColor={theme.tmpContentTitleColor}
                        />
                     ))}
                  </View>
               </View>
            )}
            {user.certifications.length > 0 && (
               <View
                  width="100%"
                  marginTop="20px[a-d] 30px[e-f]">
                  <Text
                     size={theme.tmpBodyTextSize}
                     weight="medium"
                     color={theme.tmpContentTitleColor}>
                     Certifications
                  </Text>
                  <View maxWidth="650px" marginTop="10px" opacity="0.5">
                     {user.certifications.map(certification => (
                        <Token
                           key={certification}
                           backgroundColor={tokenBackgroundColor}
                           name={certification}
                           size="lg"
                           textColor={theme.tmpContentTitleColor}
                        />
                     ))}
                  </View>
               </View>
            )}
         </View>
         <View
            flex="0 0 auto"
            maxWidth="350px[a-d]"
            display="flex"
            marginTop="20px">
            <ProfileActions />
         </View>
      </View>
   )
}

export default ProfileAboutBlock
